import { render, staticRenderFns } from "./shift-view-authorization.vue?vue&type=template&id=de40bf58&scoped=true&"
import script from "./shift-view-authorization.vue?vue&type=script&lang=js&"
export * from "./shift-view-authorization.vue?vue&type=script&lang=js&"
import style0 from "./shift-view-authorization.vue?vue&type=style&index=0&id=de40bf58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de40bf58",
  null
  
)

export default component.exports